<template>
<div>
  <v-snackbar
    :timeout=10000
    :value="isVisible"
    bottom right
    multi-line
    @input="showNextSnackbar"
  >
    {{ message }}

    <template v-slot:action="{ attrs }">
      <v-btn
        :color="color"
        @click="executeAction"
        text
        v-bind="attrs"
      >
        {{ btnText }}
      </v-btn>
    </template>
  </v-snackbar>
  <v-snackbar bottom right :value="updateExists" :timeout="-1" color="primary">
    Hay una actualización nueva!
    <v-btn text @click="refreshApp">
      Actualizar
    </v-btn>
  </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import update from '@/mixins/update'

export default {
  name: 'FhSnackbar',
  computed: {
    ...mapState('snackbar', [
      'isVisible',
      'message',
      'color',
      'actionText',
      'actionFunction',
    ]),
    btnText() {
      return this.actionText || 'Cerrar'
    },
  },
  mixins: [update],
  methods: {
    ...mapActions('snackbar', [
      'showNextSnackbar'
    ]),
    executeAction() {
      if (this.actionFunction) {
        this.actionFunction()
      }
      this.showNextSnackbar()
    },
  }
}
</script>

<style scoped>
.v-snack.v-snack--top {
  bottom: auto;
}

.v-snack.v-snack--bottom {
  top: auto;
}
</style>
